import React, { memo, useMemo } from 'react';
import Tooltip from '../Tooltip.jsx';

const CellRenderer = memo(({node, value, valueFormatted, data = {}, column: {colId}, column: {colDef: {cellRendererParams = {}} = {}} = {}}) => {
  const style = useMemo(() => {
    const {
      has_background_color = false,
      column_type = null,
      is_selection = false,
      selection_options,
    } = cellRendererParams?.original ?? {};
    if (!has_background_color || column_type !== 'text' || !is_selection) {
      return null;
    }
    const selectionObj = selection_options.find(o => o.value === value);
    return selectionObj?.color ? {backgroundColor: selectionObj.color} : null;
  }, [value, cellRendererParams]);

  const formula_errors = data.formula_errors || {};
  const val = valueFormatted || value;

  if (node?.rowPinned === 'bottom' &&
      cellRendererParams?.original?.aggregate_type != null &&
      cellRendererParams?.original?.default_aggregate === true) {
      return (
        <span>
          {val}
          <span className='description'>
            {` (${cellRendererParams?.original?.aggregate_type?.toUpperCase()})`}
          </span>
        </span>
      )
  }

  return (<>
    {formula_errors?.hasOwnProperty(colId) ?
      <Tooltip title={formula_errors[colId]}>
        <i className='fa fa-warning' />
      </Tooltip>
      :
      (style 
        ? <span className='colored-selection-cell' style={style}>{val}</span>
        : val
      )
    }
  </>);
});

export default CellRenderer;
